/**
 * @file
 * Calculator behaviors.
 */

import 'core-js/features/array/reduce';

(($, { behaviors }) => {
  /**
   * Calculate service usage.
   */
  behaviors.lvcBlock = {
    attach: (context) => {
      if (context === document) {
        const $calculatorWrapper = $('.lvc-calculator-wrapper', context);

        /**
         * Calculate annual value of all library services patron is using.
         *
         * @return {number}
         *   Total annual value of services used.
         */
        const calcAnnualValue = () => {
          // Retrieve values from all service value totals.
          const $input = $('.total-service-value', context);
          const values = $input.map((i, item) => parseFloat($(item).text()));

          // Calculate total of all service values.
          return values.toArray().reduce((a, b) => a + (b || 0), 0);
        };

        /**
         * Calculate monthly value of all library services patron is using.
         *
         * @param {number} value
         *   Total annual value of services.
         * @return {number}
         *   Total monthly value of services used.
         */
        const calcMonthlyValue = (value = calcAnnualValue()) => value / 12;

        // Update calculator totals when a value is entered.
        $calculatorWrapper.find('.input-your-use').on('change', (ev) => {
          // Get containing table
          const $serviceContainer = $(ev.currentTarget).closest('.service-row');
          // Get value of checkbox.
          const usageVal = parseFloat($(ev.currentTarget).val());
          // Get value associated with current service.
          const serviceVal = parseFloat($serviceContainer.find('.service')
            .attr('data-value'));
          // Set total value of service for column.
          $serviceContainer.find('.total-service-value')
            .text((usageVal * serviceVal).toFixed(2));
          // Calculate total monthly and annual library value.
          const totalAnnual = calcAnnualValue();
          const totalMonthly = calcMonthlyValue(totalAnnual);
          // Update value text.
          $('.total-monthly-value').text(totalMonthly.toFixed(2));
          $('.total-annual-value').text(totalAnnual.toFixed(2));
        });
      }
    },
  };
})(jQuery, Drupal);
